<template>
  <v-dialog v-model="dialog" persistent eager max-width="600">
    <v-card-title class="cyan darken-1 white--text">
      <v-icon class="white--text" left>edit</v-icon>
      Personalizza ruoli
      <v-spacer></v-spacer>
      <v-btn depressed class="white--text" light icon @click="dismiss">
        <v-icon>close</v-icon>
      </v-btn>
    </v-card-title>
    <v-sheet class="white" style="height: 550px; overflow-y: auto">
      <div class="pa-4">
        I ruoli iniziali sono quelli del listone
        <span class="label-fp">Fantapazz</span>
      </div>
      <div class="svincolati-options pa-4">
        <div class="d-flex justify-center align-center">
          <v-btn
            v-for="ruolo_id in Constants.RUOLO"
            :key="ruolo_id"
            depressed
            icon
            large
            @click.native="selectRuolo(ruolo_id)"
          >
            <span
              class="Ruolo outline"
              :class="{
                ['Ruolo_' + ruolo_id]: true,
                selezionato: selectedRuolo == ruolo_id,
              }"
              >{{ ruolo(ruolo_id) }}</span
            >
          </v-btn>
          <!-- <v-switch
            color="navy darken-2"
            v-model="onlyCustom"
            hint="Solo ruoli modificati"
            persistent-hint
            class="ml-4 custom-switch"
          ></v-switch> -->
        </div>
      </div>
      <div v-if="filtered_calciatori.length == 0" class="text-center pa-10">
        Nessun calciatore
      </div>
      <div v-else class="ruoli-custom-list">
        <RecycleScroller
          class="recycle-scroller"
          :items="filtered_calciatori"
          :item-size="65"
          ref="vscroll-list"
          :class="{ 'nice-scroll': !is_mobile }"
          v-slot="{ item: filtered_calciatore }"
        >
          <div class="ruoli-custom-list-item">
            <calciatore
              borderAsRuolo
              textScuro
              bgChiaro
              :id="filtered_calciatore.id"
            ></calciatore>
            <v-select
              dense
              v-model="newRuoli[filtered_calciatore.id]"
              :items="getRuoliSelectOptions(filtered_calciatore.id)"
              outlined
              class="selectRuolo"
              @change="handleChange(filtered_calciatore.id)"
            >
              <template #item="{ item }">
                <div v-html="item.text"></div>
              </template>

              <template #selection="{ item }">
                <div v-html="item.text"></div>
              </template>
            </v-select>
          </div>
        </RecycleScroller>
      </div>
    </v-sheet>
  </v-dialog>
</template>

<script>
import db from "../../js/db";
import Constants from "../../js/constants";
import * as Helpers from "../../js/helpers";

import mixins from "../../js/mixins";
import toast from "../../js/toast";

import Vuex from "vuex";
import AstaSvincolati from "../AstaSvincolati";
import Calciatore from "../common/Calciatore";
import { RecycleScroller } from "vue-virtual-scroller";

export default {
  name: "asta-ruoli-custom",
  mixins: [mixins, toast],
  components: { AstaSvincolati, Calciatore, RecycleScroller },
  data() {
    return {
      dialog: false,
      onlyCustom: false,
      selectedRuolo: Constants.RUOLO.P,
      newRuoli: {},
    };
  },

  mounted() {
    console.log("--> AstaARuoliCustom ready.");
    db.on("promptRuoliCustom", this.show);
    this.initNewRuoli();
  },

  destroyed() {
    console.log("<-- AstaARuoliCustom destroyed.");
    db.off("promptRuoliCustom", this.show);
  },

  methods: {
    show() {
      this.dialog = true;
    },
    dismiss() {
      this.dialog = false;
    },
    selectRuolo(ruolo) {
      this.selectedRuolo = ruolo;
    },
    initNewRuoli() {
      let _newRuoli = {};
      for (let calciatore_id in this.calciatori) {
        _newRuoli[calciatore_id] = this.calciatori[calciatore_id].ID_Ruolo;
      }
      this.newRuoli = _.assign({}, _newRuoli);
    },
    handleChange(calciatore_id) {
      // solo admin
      if (!this.admin) {
        db.emit("swalAdmin");
        return;
      }

      // asta non in corso
      if (this.isAstaInCorso) {
        db.emit(
          "swalAstaInCorso",
          "E' possibile modificare i ruoli solo dopo aver fermato l'asta"
        );
      }

      // solo se non è stato già assegnato (ovvero tra gli svincolati)
      const isSvincolato =
        this.svincolati_e_scartati_ids.includes(calciatore_id);
      if (!isSvincolato) {
        Swal.fire({
          icon: "error",
          title: "Calciatore già assegnato",
          text: "Puoi cambiare ruoli solo di calciatori ancora svincolati. Annulla l'assegnazione da ROSE e riprova.",
          confirmButtonText: "Ok, ho capito",
        });
        return;
      }

      const newRuolo = this.newRuoli[calciatore_id];
      const originalRuolo = this.calciatoriOriginal[calciatore_id].ID_Ruolo;
      const nomeCalciatore = this.calciatoriOriginal[calciatore_id].calciatore;
      let promise;
      if (newRuolo != originalRuolo) {
        promise = db.setCalciatoreCustom(calciatore_id, newRuolo);
      } else {
        promise = db.removeCalciatoreCustom(calciatore_id);
      }
      promise
        .then(() => {
          const msg =
            "Ruolo " +
            nomeCalciatore +
            " modificato in " +
            this.ruolo(newRuolo);
          this.successToast(msg, "");
        })
        .catch(() => {
          this.errorToast("Ruolo non modificato", "");
        });
    },
  },
  computed: {
    filtered_calciatori() {
      return this.calciatori_filter(this.selectedRuolo, this.calciatori);
    },
    ...Vuex.mapGetters([
      "calciatori",
      "calciatoriOriginal",
      "calciatoriCustom",
      "svincolati_e_scartati_ids",
      "calciatori_ids",
    ]),
  },
};
</script>
<style lang="scss" scoped>
// .ruoli-custom-list .recycle-scroller {
//   // vale per la dialog
//   height: 400px; // importante: deve essere specificato altrimenti reycler-scroller non funzionerà
//   // e serve anche per far scrollare solo la lista invece che tutta la dialog
// }
span.Ruolo {
  font-size: 11px;
  width: 25px;
  height: 25px;
  box-shadow: none;
  &.selezionato {
    width: 40px;
    height: 40px;
    // box-shadow: none;
  }
}
.ruoli-custom-list-item {
  position: relative;
  .v-input {
    position: absolute;
    top: 0;
    right: 5px;
    max-width: 100px;
    width: 100px;
  }
}
</style>
